import { render, staticRenderFns } from "./solutions-view.vue?vue&type=template&id=766971c0&scoped=true"
import script from "./solutions-view.vue?vue&type=script&lang=js"
export * from "./solutions-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766971c0",
  null
  
)

export default component.exports